import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import { GET_MAP_TOKEN_REFRESH_PATH, GetMapTokenRefreshSuccessDto } from '@/api/rest/resources/types/token';

const fetchMapTokenRefresh = async (): Promise<GetMapTokenRefreshSuccessDto> => {
  return getRequest(GET_MAP_TOKEN_REFRESH_PATH);
};

export const useMapTokenRefresh = () => {
  return useSuspenseQuery({
    queryKey: ['mapTokenRefresh'],
    queryFn: fetchMapTokenRefresh,
    staleTime: 1000 * 60 * 60 * 12,
    refetchInterval: 1000 * 60 * 60 * 12,
    refetchOnWindowFocus: false,
  });
};
